import React, { useState, useEffect } from 'react';
import { Bell } from 'lucide-react';
import { getRealtimeManager } from '../services/realtimeService';
import NotificationsDropdown from './NotificationsDropdown';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

const NotificationButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const realtimeManager = getRealtimeManager();
    if (!realtimeManager) return;

    setUnreadCount(realtimeManager.getUnreadCount());

    const handleRealtimeUpdate = (event, data) => {
      switch (event) {
        case 'notifications_loaded':
        case 'new_notification':
        case 'notification_updated':
        case 'notification_read':
        case 'all_notifications_read':
          setUnreadCount(data.unreadCount);
          break;
        case 'notification_clicked':
          console.log('Notification clicked:', data.notification);
          break;
        default:
          break;
      }
    };

    realtimeManager.addListener(handleRealtimeUpdate);

    return () => {
      realtimeManager.removeListener(handleRealtimeUpdate);
    };
  }, []);

  return (
    <div className="relative">
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={() => setIsOpen(!isOpen)}
        title="Notifications"
        className="relative"
      >
        <Bell className="h-5 w-5" />
        {unreadCount > 0 ? (
          <Badge
            variant="destructive"
            className="absolute -end-1 -top-1 h-5 min-w-5 justify-center rounded-full px-1 text-[10px]"
          >
            {unreadCount > 99 ? '99+' : unreadCount}
          </Badge>
        ) : null}
      </Button>

      <NotificationsDropdown isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </div>
  );
};

export default NotificationButton;
